/** Rows the sidebar "Searches" list shows before folding into "Show N more". */
export const MAX_VISIBLE_SEARCHES = 12;

export const springTransition = {
  type: "spring" as const,
  damping: 25,
  stiffness: 400,
  mass: 0.6,
};

export const layoutSpring = {
  type: "spring" as const,
  damping: 30,
  stiffness: 420,
  mass: 0.55,
};

/**
 * Per-search identity swatches — the same six hues the command palette uses
 * for its entity discs, so a search keeps one colour everywhere it appears.
 */
export const SEARCH_DOT_PALETTE = [
  "#de9c50", // gold
  "#7c5cff", // violet
  "#4f78e0", // blue
  "#0f9d8f", // teal
  "#d4588f", // rose
  "#528fc9", // sky
] as const;

/** Stable palette pick for an id (djb2-style hash). */
export function searchDotColor(id: string): string {
  let hash = 5381;
  for (let i = 0; i < id.length; i++) {
    hash = ((hash << 5) + hash + id.charCodeAt(i)) | 0;
  }
  return SEARCH_DOT_PALETTE[Math.abs(hash) % SEARCH_DOT_PALETTE.length];
}
